import React, { useEffect } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import './AlertToast.scss'

const MySwal = withReactContent(Swal);

interface AlertToastProps {
    icon: "success" | "error" | "warning" | "info";
    title: string;
    closeAlert: () => void;
}

const AlertToast: React.FC<AlertToastProps> = ({ icon, title , closeAlert }) => {
    useEffect(() => {
        const Toast = MySwal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            willClose: () => {
                closeAlert()
            }
        });
        
        setTimeout(() => {
            Toast.fire({
                icon,
                title,
            });
        }, 100);
    }, [icon, title]);

    return null;
};

export default AlertToast;
